module.exports = ".condition-container {\n  height: 34px;\n  padding: 4px 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.condition-container .switcher {\n  margin: 0 10px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/multi-choice-dropdown/multi-choice-dropdown.component.less
// module id = ./src/app/shared/components/multi-choice-dropdown/multi-choice-dropdown.component.less
// module chunks = main